import { FC, useCallback, useMemo, useState } from 'react';
import { Box, Dialog, IconButton, Stack } from '@mui/material';
import { Close } from '@mui/icons-material';
import { SignUp, Login, ResetPassword } from '@modules/Auth/views';


type Step = 'signup' | 'login' | 'forgotPassword' | 'resetPassword';

interface Props {
  open: boolean,
  onClose: () => void,
  options?: {
    step?: Step;
    onAuthenticationSuccess?: () => void;
    userData?: {
      firstName: string;
      email: string;
      phone: string;
    }
  };
}

export const AuthenticationDialog: FC<Props> = (props) => {
  const { open, onClose, options } = props;
  const { userData } = options ?? {};
  const [currentStep, setCurrentStep] = useState<Step>(options?.step || 'signup');

  const normalizedUserData = useMemo(
    () => ({
      firstName: userData?.firstName ?? '',
      phone: userData?.phone ?? '',
      email: userData?.email ?? '',
    }),
    [userData?.firstName, userData?.phone, userData?.email],
  );
  const onAuthenticated = useCallback(() => {
    onClose();
    options?.onAuthenticationSuccess?.();
  }, [onClose, options]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
    >
      <Box maxWidth={650} px={2}>
        <Stack alignItems="flex-end">
          <IconButton
            aria-label="close"
            onClick={onClose}
            size="small"
            sx={{ margin: '10px' }}
          >
            <Close/>
          </IconButton>
        </Stack>
        <Box>
          {currentStep === 'login' && (
            <Login
              onLoggedIn={onAuthenticated}
              onNoAccount={() => setCurrentStep('signup')}
              onGoToResetPassword={() => setCurrentStep('forgotPassword')}
            />
          )}
          {currentStep === 'forgotPassword' && (
            <ResetPassword
              onBackToLogin={() => setCurrentStep('login')}
            />
          )}
          {currentStep === 'signup' && (
            <SignUp
              onSignedUp={onAuthenticated}
              onAlreadyHaveAccount={() => setCurrentStep('login')}
              userData={normalizedUserData}
            />
          )}

        </Box>
      </Box>
    </Dialog>
  );
};
